module.exports = __webpack_public_path__ + "static/media/video-player.7782dc14.png";